import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

// Font Awesome imports
import '@fortawesome/fontawesome-free/css/all.css'

const originalFetch = window.fetch?.bind(window)
if (originalFetch) {
  window.fetch = async (...args) => {
    const response = await originalFetch(...args)
    try {
      if (response && (response.status === 401 || response.status === 403)) {
        const contentType = response.headers?.get('content-type') || ''
        if (contentType.includes('application/json')) {
          const clone = response.clone()
          const data = await clone.json().catch(() => null)
          if (data?.requiresLoginOtp && router.currentRoute.value.path !== '/verification') {
            if (!window.__loginOtpRedirecting) {
              window.__loginOtpRedirecting = true
              const query = { mode: 'login' }
              if (data.email) query.email = data.email
              router.push({ path: '/verification', query }).finally(() => {
                window.__loginOtpRedirecting = false
              })
            }
          }
        }
      }
    } catch (error) {
      // Ignore redirect errors and allow response to flow to callers.
    }
    return response
  }
}

createApp(App)
  .use(createPinia())
  .use(router)
  .mount('#app')
